import { Component } from '@angular/core';
import { Loading, LoadingController, NavController } from 'ionic-angular';
import { Api } from "../../../providers/api";
import { PostRegisterLicenseResponse } from "../../../providers/api/responses/PostRegisterLicenseResponse";
import { PostRegisterLicenseRequest } from "../../../providers/api/requests/PostRegisterLicenseRequest";
import { UnauthorizedError } from "../../../providers/api/errors/UnauthorizedError";
import { ForbiddenError } from "../../../providers/api/errors/ForbiddenError";
import { Storage } from "@ionic/storage";
import { DesktopService } from "../../../providers/desktop-service";
import { DirectoryService } from "../../../providers/directory-service";
import { LicenceOkPage } from "../licence-ok/licence-ok";

@Component({
    selector: 'page-licence-prompt',
    templateUrl: 'licence-prompt.html',
})

export class LicencePromptPage {
    public license_key: string = '';
    public hasError: boolean = false;

    constructor(
        private navCtrl: NavController,
        private api: Api,
        private loadingCtrl: LoadingController,
        private storage: Storage,
        private desktopService: DesktopService,
        private directoryService: DirectoryService,
    ) {

    }

    public async attemptLicenseActivation() {
        let loading: Loading = this.loadingCtrl.create();
        loading.present();

        const request: PostRegisterLicenseRequest = { license: this.license_key };
        this.api.postRegisterLicense(request)
          .finally(() => { loading.dismiss(); })
          .subscribe(async (response: PostRegisterLicenseResponse) => {
              await this.storage.set('api_token', response.token);
              this.api.setToken(response.token);

              await this.directoryService.setNavCtrl(this.navCtrl);
              await this.navCtrl.setRoot(LicenceOkPage);
          }, async er => {
              switch (er.constructor) {
                  case UnauthorizedError:
                  case ForbiddenError:
                  default:
                      this.hasError = true;
              }
          });
    }

}



// WEBPACK FOOTER //
// ./src/pages/desktop/licence-prompt/licence-prompt.ts